import { render, staticRenderFns } from "./NotificacionFaltas.vue?vue&type=template&id=32336f56"
import script from "./NotificacionFaltas.vue?vue&type=script&lang=js"
export * from "./NotificacionFaltas.vue?vue&type=script&lang=js"
import style0 from "./NotificacionFaltas.vue?vue&type=style&index=0&id=32336f56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports